<template>
    <div>

        <div class="ticketing_queue_details" v-if="ticketDetail">
            <div class="card ">
                <header class="card-header grey-header d-flex">
                    <div class="row flex-flow-column">
                        <div class="col"><strong>{{$t("cTicketingDetail.bookingDetails")}}</strong></div>
                        <p class="desc">{{$t("cTicketingDetail.desc")}}
                        </p></div>
                </header>
                <div class="card-body">
                    <div class="wrapper_body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="main_card">
                                    <div class="row w-100">
                                        <div class="col-md-2 col-sm-4 col-xs-2">
                                            <div class="content-wrap">
                                                <div class="t-wrap">
                                                    <div :class="'indicate-dot'+ ' '+ getStatusClass(ticketDetail)">
                                                        <div></div>

                                                    </div>



                                                    
                                                    <span   :class="'indicate-dot-text ' +' '+getStatusClass(ticketDetail)">


                            <span v-if=" getStatusClass(ticketDetail) == 'paid'">{{$t("cTicketingDetail.ticketed")}}</span>
                            <span v-if=" getStatusClass(ticketDetail) == 'unpaid'&&ticketDetail.orderStatus==11">{{$t("cTicketingDetail.pending")}}</span>
                           <span v-if=" getStatusClass(ticketDetail) == 'partial_paid'">{{$t("cTicketingDetail.hold")}}</span>
 <span v-if=" getStatusClass(ticketDetail) == 'unpaid'&&ticketDetail.orderStatus==15">{{$t("cTicketingDetail.cancelled")}}</span>
 <span v-if=" getStatusClass(ticketDetail) == 'unpaid'&&ticketDetail.orderStatus==8">{{$t("cTicketingDetail.payStatusPending")}}</span>
                       </span>


                                                    <!-- <div class="indicate-dot partial_paid">
                                                      <div></div>
                                                    </div>
                                                    <span class="indicate-dot-text partial_paid">
                                                      <span>Hold</span>
                                                    </span> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-sm-4 col-xs-2">
                                            <div class="title">
                                                {{$t("cTicketingDetail.reservationId")}}
                                            </div>
                                            <div class="value" v-if="ticketDetail.orderID">
                                                {{ticketDetail.orderID}}
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-sm-4 col-xs-2">
                                            <div class="title">
                                                {{$t("cTicketingDetail.dateOfBooking")}}
                                            </div>
                                            <div class="value" v-if="ticketDetail.bookingDate">
                                                {{ticketDetail.bookingDate|formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-sm-4 col-xs-2" v-if="ticketDetail.orderStatus == 10 || ticketDetail.orderStatus == 7">

                                            <div v-if="ticketDetail.orderStatus == 10 ">
                                                <div class="title">

                                                   {{$t("cTicketingDetail.ticketIssueDate")}} </div>
                                                <div class="value">
                                                    {{ticketDetail.ticketissueDate | formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                </div>
                                            </div>
                                            <div v-if="ticketDetail.orderStatus == 7 ">

                                                <div v-if="checkStatus(ticketRowObj)&&ticketRowObj&&ticketRowObj.ticketingdeadline">
                                                    <div class="title">

                                                        {{$t("cTicketingDetail.ticketDeadline")}}  </div>
                                                    <div class="value">
                                                        {{ticketRowObj.ticketingdeadline | formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <div class="col-md-2 col-sm-4 col-xs-2">
                                            <div class="title">
                                                {{$t("cTicketingDetail.bookBy")}}
                                            </div>
                                            <div class="value" v-if="ticketDetail&&ticketDetail.booked_agent">
                                                {{ticketDetail.booked_agent}}
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-sm-4 col-xs-2">
                                            <div class="title">
                                                 {{$t("cTicketingDetail.amount")}}
                                            </div>
                                            <div class="value"
                                                 v-if="ticketDetail&&ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].TotalAmount&&ticketDetail.orderPaymentDetails[0].currency">
                                                {{ticketDetail.orderPaymentDetails[0].currency+' '}}{{ticketDetail.orderPaymentDetails[0].TotalAmount|formatNumber(ticketDetail.orderPaymentDetails[0].currency)}}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="ticketDetail">
                                <div class="tickting_details">
                                    <div class="m_title">
                                        {{$t("cTicketingDetail.ticketDetails")}}
                                    </div>
                                    <div class="m_content">
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>
                                                    {{$t("cTicketingDetail.passengers")}}
                                                </th>
                                                <th>
                                                   {{$t("cTicketingDetail.contactDetails")}}
                                                </th>
                                                <th>
                                                  {{$t("cTicketingDetail.reference")}}
                                                </th>
                                                <th>
                                                   {{$t("cTicketingDetail.route")}}
                                                </th>
                                                <th>
                                                    {{$t("cTicketingDetail.flightNumber")}}
                                                </th>
                                                <th>
                                                     {{$t("cTicketingDetail.travelDate")}}
                                                </th>
                                                <th>
                                                     {{$t("cTicketingDetail.pnr")}}
                                                </th>
                                                <th>
                                                    <!-- :class="{mw_300 : !checkHoldByOrderStatus(ticketDetail)}" v-if="!checkHoldByOrderStatus(ticketDetail)" -->
                                                   {{$t("cTicketingDetail.ticketNumber")}}
                                                </th>

                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <div v-if="ticketRowObj&&ticketRowObj.passengername">
                                                        <div>
                                                            {{ticketRowObj.passengername}}
                                                        </div>
                                                        <div>{{getPassengerCount(ticketRowObj)+' '}}{{getPassDisplayText(getPassengerCount(ticketRowObj))}}
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        {{'-'}}

                                                    </div>

                                                </td>
                                                <td>
                                                    <div v-if="ticketDetail&&ticketDetail.contactDetails&&ticketDetail.contactDetails.mobileCode&&ticketDetail.contactDetails.mobileNo">
                                                        <div>
                                                            {{ticketDetail.contactDetails.mobileCode+' '+ticketDetail.contactDetails.mobileNo}}
                                                        </div>
                                                        <div v-if="ticketDetail.contactDetails.email">
                                                            {{ticketDetail.contactDetails.email}}
                                                        </div>
                                                    </div>


                                                    <div v-else>
                                                        {{''}}

                                                    </div>

                                                </td>
                                                <td>
                                                    <div v-if="ticketDetail&&ticketDetail.reference">

                                                        {{ticketDetail.reference}}

                                                    </div>
                                                    <div v-else>
                                                        {{''}}

                                                    </div>

                                                </td>
                                                <td>
                                                    <div v-if="ticketRowObj&&ticketRowObj.FlightDetails">
                                                        <div v-if="ticketRowObj.journeytype==2">
                                                            {{ticketRowObj.FlightDetails[0].departure+' - '+
                                                            ticketRowObj.FlightDetails[0].arrival }}
                                                        </div>
                                                        <div v-else
                                                             v-for="(flightObj,index) in ticketRowObj.FlightDetails"
                                                             :key="index">{{flightObj.departure+' - '+
                                                            flightObj.arrival }}
                                                        </div>
                                                        <div v-if="ticketRowObj.journeytype">
                                                            {{getTripDisPlayText(ticketRowObj.journeytype)}}
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        {{''}}

                                                    </div>

                                                </td>
                                                <td>
                                                    <div v-for="(flightObj,index) in ticketDetail.flights"
                                                         :key="index">
                                                        <div v-if="flightObj&&flightObj.flight">
                                                            <div>
                                                                <div v-for="(flightNum,index) in flightObj.flight.FlightNo.split(',')"
                                                                     :key="'t'+index">{{flightNum}}
                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div v-else>
                                                            {{''}}
                                                        </div>


                                                    </div>
                                                </td>
                                                <td class="white-space-pre">
                                                    <div v-if="ticketDetail.journeyType">
                                                        <div v-if="ticketDetail.journeyType!=2">
                                                            <div v-for="(flightObj,index) in ticketDetail.flights"
                                                                 :key="index">
                                                                {{flightObj.flight.DepDate|formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                            </div>
                                                        </div>
                                                        <div v-if="ticketDetail.journeyType==2">
                                                            <div v-if="ticketDetail.flights&&ticketDetail.flights[0].flight">{{ticketDetail.flights[0].flight.DepDate|formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                            </div>
                                                            <div>
                                                                {{ticketDetail.flights[ticketDetail.flights.length-1].flight.DepDate|formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        {{''}}

                                                    </div>

                                                </td>
                                                <td>
                                                    <div v-if="ticketDetail&&ticketDetail.pnr">
                                                        <div v-for="(pnrObj,index) in ticketDetail.pnr"
                                                             :key="index">
                                                            <div v-if="pnrObj">
                                                                {{pnrObj}}
                                                            </div>
                                                            <div v-else>
                                                                {{''}}

                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        {{''}}

                                                    </div>

                                                </td>
                                                <td>
                                                    <div v-if="!checkHoldByOrderStatus(ticketDetail)">
                                                        <div>
                                                            <div v-if="ticketDetail&&ticketDetail.ticketNumbers && ticketDetail.ticketNumbers.length<3">
                                                            <div 
                                                                 v-for="(tickNumber,index) in ticketDetail.ticketNumbers"
                                                                 :key="index">
                                                                <div v-if="tickNumber">
                                                                    {{tickNumber}}
                                                                    <!-- <span
                                                                        v-if="ticketDetail.ticketNumbers.length >= 2">,</span> -->
                                                                </div>
                                                                <div v-else>
                                                                    {{'--'}}

                                                                </div>
                                                                </div>

                                                            </div>
                                                            <div v-if="ticketDetail&&ticketDetail.ticketNumbers && ticketDetail.ticketNumbers.length>=3">
                                                                <p class="hyperlink-c" @click="showTktNumbers"><label>{{$t("cTicketingDetail.view")}}</label>
                                                                </p>
                                                            </div>
                                                            <div v-if="ticketDetail&&ticketDetail.ticketNumbers&&ticketDetail.ticketNumbers.length==0">
                                                                {{'--'}}
                                                            </div>
                                                        </div>


                                                    </div>
                                                    <div v-else>
                                                        {{'--'}}

                                                    </div>
                                                </td>


                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                 <div class="flight-details" v-if="tcktDetLs">
    <div class="m_title">{{$t("cTicketingDetail.flightDetails")}}</div>
    <!-- <pre class="language-json"><code>{{ flightListbyGroup  }}</code></pre> -->
    <div class="m_content" v-if="flightListbyGroup.length>0">
      <div class="f_card" v-for="(flightObj,index) in flightListbyGroup" :key="'f'+index">
        <div class="flight_info" v-if="flightObj.flightGroup.length>0">
          <div class="flight_d" v-if="tcktDetLs.airlines">
            <div class="icon">
              <img
                v-if="flightObj.flightGroup[0].flight.opAirline"
                :src="tcktDetLs.airlines[flightObj.flightGroup[0].flight.opAirline].logourl"
                :onerror="defaultALImg"
                width="40px"
              />
            </div>
            <div class="text">
              <div>{{flightObj.flightGroup[0].flight.FlightNo}}</div>
              <span class="d-flex">
                {{tcktDetLs.airlines[flightObj.flightGroup[0].flight.opAirline].airline_name +' '
                }} |
                <span
                  class="ml-5px d-flex"
                >
                  <div>{{flightObj.flightGroup[0].flight.DepAirport+' - '+flightObj.flightGroup[flightObj.flightGroup.length-1].flight.ArrAirport}}</div>
                </span>
              </span>
            </div>
          </div>
          <div class="class-des">
            <div v-if="tcktDetLs.journeyType==3">{{$t("cTicketingDetail.leg")+' '+(index+1)}}</div>
            <div
              v-else
            >{{flightObj.id.includes("_IB")?$t("cTicketingDetail.departure"):$t("cTicketingDetail.return")}}</div>
            <span>Class {{flightObj.flightGroup[0].flight.Bookingclass}}</span>
          </div>
        </div>
        <div
          class="flight_t_info"
          v-if="flightObj.flightGroup.length>0 && flightObj.flightGroup[0].flight"
          @click="flightObj.flightGroup.length>1?showConnectingFlights():null"
          >
          <div class="text-right">
            <span
              v-if="flightObj.flightGroup[0].flight.DepDate"
            >{{flightObj.flightGroup[0].flight.DepDate|formatDate}}</span>
            <div
              class="time"

            >{{flightObj.flightGroup[0].flight.DepDate|formatDate("HH:mm")}}</div>
            <span
              v-if="flightObj.flightGroup[0].flight.DepAirport"
            >{{tcktDetLs.airports[flightObj.flightGroup[0].flight.DepAirport].airportname}}</span>
          </div>
          <div class="f_icon">
            <img src="~@imgPath/img/svg/icons/flight-black.svg" alt />
            <br />
           
            <span v-if="!isStopsForNonMyanmar" class="stop">{{getStops(flightObj.flightGroup)}}</span>
           
            <span v-else-if="isStopsForNonMyanmar" class="via">{{getStops(flightObj.flightGroup)}} 
                {{getVia(flightObj.flightGroup)}}</span>
          </div>
          <div
            class="text-left"
            v-if="flightObj.flightGroup[flightObj.flightGroup.length-1].flight.ArrDate"
          >
            <span>{{flightObj.flightGroup[flightObj.flightGroup.length-1].flight.ArrDate|formatDate}}</span>
            <div
              class="time"
              v-if="flightObj.flightGroup[flightObj.flightGroup.length-1].flight.ArrDate"
            >{{flightObj.flightGroup[flightObj.flightGroup.length-1].flight.ArrDate|formatDate("HH:mm")}}</div>
            <span
              v-if="flightObj.flightGroup[flightObj.flightGroup.length-1].flight.ArrAirport"
            >{{tcktDetLs.airports[flightObj.flightGroup[flightObj.flightGroup.length-1].flight.ArrAirport].airportname}}</span>
          </div>
        </div> 
         <cTicketingConnectionFlight v-if="isShowMore && flightObj.flightGroup.length>1" 
             :ticketDetail="flightObj.flightGroup" :ticketingDetail="tcktDetLs"> </cTicketingConnectionFlight>
         </div></div></div>

                               
                                <!-- <div class="flight-details">
                                    <div class="m_title">
                                        {{$t("cTicketingDetail.flightDetails")}}
                                    </div>
                                    <div class="m_content">
                                        <div class="f_card" v-for="(flightObj,index) in ticketDetail.flights"
                                             :key="index">
                                            <div class="flight_info">
                                                <div class="flight_d">
                                                    <div class="icon">
                                                        <img
                                                                v-if="ticketDetail.airlines"
                                                                :src="ticketDetail.airlines[flightObj.flight.opAirline].logourl"
                                                                :onerror="defaultALImg" width="40px"
                                                        />
                                                    </div>
                                                    <div class="text">
                                                        <div>{{flightObj.flight.FlightNo}}</div>
                                                        <span class="d-flex">
           {{ticketDetail.airlines[flightObj.flight.opAirline].airline_name +' '
                                                        }}   | <span class="ml-5px d-flex">
                                                            <div>
   {{flightObj.flight.DepAirport+' - '+flightObj.flight.ArrAirport}}
                                                            </div>
                                                         
                                                        </span> -->
                                                            <!-- <span class="ml-5px d-flex" v-if="ticketRowObj.FlightDetails">
                                                               <div v-if="ticketRowObj.journeytype==2">
                                                           {{ticketRowObj.FlightDetails[0].departure+' - '+
                                                           ticketRowObj.FlightDetails[0].arrival }}
                                                               </div>
                                                               <div v-else v-for="(flightObj,index) in ticketRowObj.FlightDetails"
                                                               :key="index">{{flightObj.departure+' - '+
                                                               flightObj.arrival }}
                                                                   <span v-if="index >= 1 " class="mr-5px">,</span>
                                                               </div>
                                                    </span> -->
         <!--  </span>
                                                  </div>
                                                </div>
                                                <div class="class-des">
                                                    <div v-if="ticketDetail.journeyType==3">
                                                        {{$t("cTicketingDetail.leg")+' '+(index+1)}}
                                                    </div>
                                                    <div v-else>
                                                        {{ticketDetail.journeyType==2&&index==1?$t("cTicketingDetail.return"):$t("cTicketingDetail.departure")}}
                                                    </div>
                                                    <span>
Class {{flightObj.flight.Bookingclass}}
                                        </span>
                                                </div>
                                            </div>
                                            <div class="flight_t_info">
                                                <div class="text-right">
                                                    <span v-if="flightObj.flight.DepDate">{{flightObj.flight.DepDate|formatDate("DD-MMM-YYYY")}}</span>
                                                    <div class="time" v-if="flightObj.flight.DepDate">
                                                        {{flightObj.flight.DepDate|formatDate("HH:mm")}}
                                                    </div>
                                                    <span v-if="flightObj.flight.DepAirport"> {{ticketDetail.airports[flightObj.flight.DepAirport].airportname}}</span>
                                                </div>
                                                <div class="f_icon">
                                                    <img src="~@imgPath/img/svg/icons/flight-black.svg" alt="">
                                                </div>
                                                <div class="text-left" v-if="flightObj.flight.ArrDate">
                                                    <span>{{flightObj.flight.ArrDate|formatDate("DD-MMM-YYYY")}}</span>
                                                    <div class="time" v-if="flightObj.flight.ArrDate">
                                                        {{flightObj.flight.ArrDate|formatDate("HH:mm")}}
                                                    </div>
                                                    <span v-if="flightObj.flight.ArrAirport">   {{ticketDetail.airports[flightObj.flight.ArrAirport].airportname}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div> -->
                            </div>
                            <div class="col-md-4">
                                <div class="payment_details">
                                    <div class="m_title">
                                        {{$t("cTicketingDetail.paymentDetails")}}
                                    </div>
                                    <div class="m_content">
                                        <div class="wrap">
                                            <div class="title">
                                                {{$t("cTicketingDetail.bookingStatus")}}
                                            </div>
                                            <div class="content_wrap">
                                                <div class="row">
                                                    <div class="col-6">
                                                         {{$t("cTicketingDetail.bookingStatus")}}
                                                    </div>
                                                    <div class="col-6" v-if="ticketDetail.orderStatusString">

                                                        {{ticketDetail.orderStatusString}}
                                                    </div>
                                                    <div class="col-6">
                                                       {{$t("cTicketingDetail.bookedBy")}}
                                                    </div>
                                                    <div class="col-6"
                                                         v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].userName">
                                                        {{ticketDetail.orderPaymentDetails[0].userName}}
                                                    </div>
                                                    <div class="col-6">
                                                        {{$t("cTicketingDetail.transactionId")}}
                                                    </div>
                                                    <div class="col-6" v-if="ticketDetail.transactionId">
                                                        {{ticketDetail.transactionId}}
                                                    </div>
                                                    <div class="col-6">
                                                        {{$t("cTicketingDetail.paymentType")}}
                                                    </div>
                                                    <div class="col-6"
                                                         v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].paymentType">
                                                        {{ticketDetail.orderPaymentDetails[0].paymentType}}
                                                    </div>
                                                    <div class="col-6"
                                                         v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].approvalCode">
                                                        {{$t("cTicketingDetail.approvalCode")}}
                                                    </div>
                                                    <div class="col-6"
                                                         v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].approvalCode">
                                                        {{ticketDetail.orderPaymentDetails[0].approvalCode}}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="wrap">
                                            <div class="title">
                                               {{$t("cTicketingDetail.pricingDetails")}}
                                            </div>
                                            <div class="content_wrap">
                                                <div class="row">
                                                    <table class="pricing-details-table">
                                                        <tr>
                                                            <td>
                                                                <div>
                                                                    {{$t("cTicketingDetail.orderAmt")}}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div  v-if="ticketDetail&&ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].OrderAmount&&ticketDetail.orderPaymentDetails[0].currency">
                                                                    {{ticketDetail.orderPaymentDetails[0].currency+' '}}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div  v-if="ticketDetail&&ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].OrderAmount&&ticketDetail.orderPaymentDetails[0].currency">
                                                                    {{ticketDetail.orderPaymentDetails[0].OrderAmount|formatNumber(ticketDetail.orderPaymentDetails[0].currency)}}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div>
                                                                    {{$t("cTicketingDetail.paymentFee")}}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].PaymentFee&&ticketDetail.orderPaymentDetails[0].currency">
                                                                    {{ticketDetail.orderPaymentDetails[0].currency+' '}}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].PaymentFee&&ticketDetail.orderPaymentDetails[0].currency">
                                                                    {{ticketDetail.orderPaymentDetails[0].PaymentFee|formatNumber(ticketDetail.orderPaymentDetails[0].currency)}}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div>
                                                                    {{$t("cTicketingDetail.totalAmt")}}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].TotalAmount&&ticketDetail.orderPaymentDetails[0].currency">
                                                                    {{ticketDetail.orderPaymentDetails[0].currency+' '}}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].TotalAmount&&ticketDetail.orderPaymentDetails[0].currency">
                                                                    {{ticketDetail.orderPaymentDetails[0].TotalAmount|formatNumber(ticketDetail.orderPaymentDetails[0].currency)}}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <!-- <div class="col-6">{{$t("cTicketingDetail.currency")}}</div>

                                                    <div class="col-6"
                                                         v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].currency">
                                                        {{ticketDetail.orderPaymentDetails[0].currency}}
                                                    </div> -->

<!--                                                    <div class="col-md-6">{{$t("cTicketingDetail.orderAmt")}}</div>-->
<!--                                                    <div class="col-md-6"-->
<!--                                                         v-if="ticketDetail&&ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].OrderAmount&&ticketDetail.orderPaymentDetails[0].currency">-->
<!--                                                        {{ticketDetail.orderPaymentDetails[0].currency+'-->
<!--                                                        '}}{{ticketDetail.orderPaymentDetails[0].OrderAmount|formatNumber(ticketDetail.orderPaymentDetails[0].currency)}}-->
<!--                                                    </div>-->
<!--                                                    <div class="col-md-6">{{$t("cTicketingDetail.paymentFee")}}</div>-->
<!--                                                    <div class="col-md-6"-->
<!--                                                         v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].PaymentFee&&ticketDetail.orderPaymentDetails[0].currency">-->
<!--                                                        {{ticketDetail.orderPaymentDetails[0].currency+'-->
<!--                                                        '}}{{ticketDetail.orderPaymentDetails[0].PaymentFee|formatNumber(ticketDetail.orderPaymentDetails[0].currency)}}-->
<!--                                                    </div>-->


                                                </div>
                                            </div>

                                        </div>
<!--                                        <div class="total_amount">-->
<!--                                            <div class="row">-->
<!--                                                <div class="col-md-6">-->
<!--                                                    {{$t("cTicketingDetail.totalAmt")}}-->
<!--                                                </div>-->
<!--                                                <div class="col-md-6"-->
<!--                                                     v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].TotalAmount&&ticketDetail.orderPaymentDetails[0].currency">-->
<!--                                                    {{ticketDetail.orderPaymentDetails[0].currency+'-->
<!--                                                    '}}{{ticketDetail.orderPaymentDetails[0].TotalAmount|formatNumber(ticketDetail.orderPaymentDetails[0].currency)}}-->
<!--                                                </div>-->

<!--                                            </div>-->
<!--                                        </div>-->
                                    </div>


                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="passenger_details">
                                    <div class="m_title">
                                        {{$t("cTicketingDetail.passengerDetails")}}
                                    </div>
                                    <div class="m_content" id="paxtable" ref="paxtable">
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>
                                               {{$t("cTicketingDetail.number")}}

                                                </th>
                                                <th>
                                                    {{$t("cTicketingDetail.name")}}
                                                </th>
                                                <th>
                                                    {{$t("cTicketingDetail.gender")}}
                                                </th>
                                                <th>
                                                    {{$t("cTicketingDetail.idNumber")}}
                                                </th>
                                                <th>
                                                    {{$t("cTicketingDetail.dob")}}
                                                </th>
                                                <th>
                                                    {{$t("cTicketingDetail.nationality")}}
                                                </th>
                                                <th v-if="!checkHoldByOrderStatus(ticketDetail)">
                                                    {{$t("cTicketingDetail.ticketNumber")}}
                                                </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <tr v-for="(passengerDetail,index) in ticketDetail.orderPassengerDetails"
                                                :key="index">
                                                <td>
                                                    {{index + 1}}
                                                </td>
                                                <td>
                                                    {{passengerDetail.paxTitle+' '+passengerDetail.firstName+' '}}{{passengerDetail.lastName}}
                                                </td>
                                                <td>
                                                    {{passengerDetail.Gender==1?$t("cTicketingDetail.male"):$t("cTicketingDetail.female")}}
                                                </td>
                                                <td>
                                                    {{passengerDetail.idNumber}}
                                                </td>
                                                <td>
                                                    {{passengerDetail.dateOfBirth|formatDate}}
                                                </td>
                                                <td>
                                                    {{passengerDetail.nationality_name}}
                                                </td>
                                                <td :class="{'highlight' : isHighLight}"
                                                    v-if="!checkHoldByOrderStatus(ticketDetail)">
                                                     <span v-for="(tickNum,index) in passengerDetail.ticketNumbers"
                                                           :key="index">
{{tickNum}}
                                                     </span>

                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <footer>
                    <div>
                        <CButton @click="navigateToPrevPage"
                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger">
                <span>
                        {{ $t('cTicketingDetail.goBackBtn') }}
                </span>
                        </CButton>
                    </div>
                    <div class="d-flex">
                        <CButton @click="onShowRetryPayModel(ticketRowObj)"
                                 v-if="AGENT_SIGNIN_RES&&!isBooking&&getRetryBtnStatus(ticketDetail)"
                                 class="btn align-right btn-lit-blue btn-success m-10px ml-auto">
                <span>
                        {{ $t('cTicketingDetail.retryPayment') }}
                </span>
                        </CButton>
                        <CButton @click="emitNav(ticketRowObj)"
                                 v-if="AGENT_SIGNIN_RES&&checkHoldByOrderStatus(ticketDetail)&&!isBooking&&!getRetryBtnStatus(ticketDetail)"
                                 class="btn align-right btn-lit-blue btn-success m-10px ml-auto">
                <span>
                        {{ $t('ticketingQueue.tcktNow') }}
                </span>
                        </CButton>
                        <CButton @click.stop="onShowCancelConfirmation(ticketRowObj)"
                                 v-if="AGENT_SIGNIN_RES&&getCancelBtnStatus(ticketDetail)"
                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger width-125px">
                <span>
                        {{ $t('ticketingQueue.cancelBtn') }}
                </span>
                        </CButton>

                        <CButton @click.stop="navToRefund(ticketRowObj)"
                                 v-if="isBooking&&AGENT_SIGNIN_RES&&getRefundStatus(ticketRowObj)"
                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger width-125px">
                <span>
                        {{ $t('ticketingQueue.refund') }}
                </span>
                        </CButton>



                        <CButton @click.stop="navToExchange(ticketRowObj)"
                                 v-if="isBooking&&AGENT_SIGNIN_RES&&getExchangeStatus(ticketRowObj)"
                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger width-125px">
                <span>
                        {{ $t('ticketingQueue.exchange') }}
                </span>
                        </CButton>
                    </div>
                </footer>
            </div>
        </div>


        <!--        <div class="booking-details-body-wrap" v-if="ticketDetail">-->
        <!--            <div class="booking-full-details">-->

        <!--                <div class="wrap-title" v-if="ticketRowObj">-->


        <!--                    <div-->
        <!--                            caption="TicketingQueue d-flex"-->
        <!--                            id="user-manage-table"-->
        <!--                            class="usersTable border-grey manage-user-table table table-striped d-flex table-hover"-->
        <!--                    >-->

        <!--                        <div class="position-relative table-responsive single-table-row">-->
        <!--                            <div class="d-flex table-blue-row">-->
        <!--                                <div class="py-2">-->
        <!--                                    <div class="t-body">-->
        <!--                                        <div class="content-wrap">-->
        <!--                                            <div class="t-wrap">-->
        <!--                                                <div :class="'indicate-dot'+ ' '+ getStatusClsByBookStatus(ticketRowObj)">-->
        <!--                                                    <div></div>-->
        <!--                                                </div>-->
        <!--                                                <span :class="'indicate-dot-text '+ ' '+ getStatusClsByBookStatus(ticketRowObj)">-->
        <!--                              &lt;!&ndash;&ndash;&gt;-->
        <!--                                                    &lt;!&ndash;&ndash;&gt;-->
        <!--                              <span v-if="ticketRowObj.bookingStatus">{{ticketRowObj.bookingStatus}}</span>-->
        <!--                            </span>-->
        <!--                                            </div>-->
        <!--                                        </div>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2">-->
        <!--                                    <div v-if="ticketRowObj.orderId">-->
        <!--                                        <strong>{{ticketRowObj.orderID}}</strong>-->
        <!--                                    </div>-->
        <!--                                    <div-->

        <!--                                    >{{ticketRowObj.bookingDate | formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2">-->
        <!--                                    <div v-if="ticketRowObj.passengername">-->
        <!--                                        <strong>{{ticketRowObj.passengername}}</strong>-->
        <!--                                    </div>-->
        <!--                                    <div>{{getPassengerCount(ticketRowObj)+'-->
        <!--                                        '}}{{getPassDisplayText(getPassengerCount(ticketRowObj))}}-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2">-->
        <!--                                    <div v-if="ticketRowObj.contactnumber">-->
        <!--                                        <strong>{{ticketRowObj.contactnumber}}</strong>-->
        <!--                                    </div>-->
        <!--                                    <div v-if="ticketRowObj.contactmail">{{ticketRowObj.contactmail}}</div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2">-->
        <!--                                    <div>-->
        <!--                                        <div>-->
        <!--                                            <div v-if="ticketRowObj.FlightDetails">-->
        <!--                                                <div v-if="ticketRowObj.journeytype==2">-->
        <!--                                                    <strong>{{ticketRowObj.FlightDetails[0].departure+' - '+-->
        <!--                                                        ticketRowObj.FlightDetails[0].arrival }}</strong>-->
        <!--                                                </div>-->
        <!--                                                <div v-else v-for="(flightObj,index) in ticketRowObj.FlightDetails"-->
        <!--                                                     :key="index">-->
        <!--                                                    <strong>{{flightObj.departure+' - '+-->
        <!--                                                        flightObj.arrival }}</strong>-->
        <!--                                                </div>-->


        <!--                                            </div>-->
        <!--                                        </div>-->
        <!--                                        <div>-->
        <!--                                            <div v-if="ticketRowObj.journeytype">-->
        <!--                                                {{getTripDisPlayText(ticketRowObj.journeytype)}}-->
        <!--                                            </div>-->
        <!--                                        </div>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2">-->
        <!--                                    <div>-->
        <!--                                        <div v-for="(flightObj,index) in ticketRowObj.FlightDetails" :key="index">-->
        <!--                                            <div v-for="(flightNum,index) in flightObj.flight_number.split(',')"-->
        <!--                                                 :key="'t'+index">{{flightNum}}-->
        <!--                                            </div>-->

        <!--                                        </div>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2">-->
        <!--                                    <div>-->
        <!--                                        <div>-->
        <!--                                            <div v-if="ticketRowObj.journeytype!=2">-->
        <!--                                                <div v-for="(flightObj,index) in ticketDetail.flights" :key="index">-->
        <!--                                                    {{flightObj.flight.DepDate|formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div v-if="ticketDetail.journeyType==2">-->
        <!--                                                <div v-if="ticketDetail.flights&&ticketDetail.flights[0].flight-->
        <!--                        ">{{ticketDetail.flights[0].flight.DepDate|formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}-->
        <!--                                                </div>-->
        <!--                                                <div>-->
        <!--                                                    {{ticketDetail.flights[ticketDetail.flights.length-1].flight.ArrDate|formatDateTime("DD-MMM-YYYY-->
        <!--                                                    HH:mm")}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->

        <!--                                            &lt;!&ndash;&ndash;&gt;-->


        <!--                                        </div>-->

        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2 pnr-number">-->
        <!--                                    <div>-->
        <!--                                        <div>-->
        <!--                                            <div v-for="(pnrObj,index) in ticketRowObj.FlightDetails" :key="index">-->
        <!--                                                {{pnrObj.pnr}}-->
        <!--                                            </div>-->
        <!--                                        </div>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2">-->
        <!--                                    <div>-->
        <!--                                        <strong>{{ticketRowObj.agencyname}}</strong>-->
        <!--                                    </div>-->
        <!--                                    <div>{{ticketRowObj.username}}</div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2 d-flex align-center amount">-->
        <!--                                    <div>-->
        <!--                                        <strong>{{ticketRowObj.currency}}</strong>-->
        <!--                                    </div>-->
        <!--                                    <div>{{ticketRowObj.amount|formatNumber(ticketRowObj.currency)}}</div>-->
        <!--                                </div>-->
        <!--                                <div class="py-2 ticketing-deadline">-->
        <!--                                    <div v-if="checkStatus(ticketRowObj)&&ticketRowObj&&ticketRowObj.ticketingdeadline">-->
        <!--                                        <div>{{ticketRowObj.ticketingdeadline | formatDateTime("DD-MMM-YYYY-->
        <!--                                            HH:mm")}}-->
        <!--                                        </div>-->
        <!--                                        <div>{{ticketRowObj.ticketingdeadline |timeAgoFormat}}</div>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                            </div>-->

        <!--                        </div>-->
        <!--                        &lt;!&ndash;            <div class="close" @click.stop="emitClose()">&ndash;&gt;-->
        <!--                        &lt;!&ndash;             &ndash;&gt;-->
        <!--                        &lt;!&ndash;              <img src="https://image.flaticon.com/icons/svg/2089/2089650.svg" width="25px" alt />&ndash;&gt;-->
        <!--                        &lt;!&ndash;            </div>&ndash;&gt;-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="wrapper">-->
        <!--                    <CRow>-->
        <!--                        <CCol md="12">-->
        <!--                            <div class="c-wrap">-->
        <!--                                <div class="pay-title">{{$t("cTicketingDetail.ticketDetails")}}</div>-->
        <!--                                <div class="ticket-detail">-->
        <!--                                    <div class="tick-status-wrap">-->
        <!--                                        <div class="content-wrap">-->
        <!--                                            <div class="t-wrap">-->
        <!--                                                <div :class="'indicate-dot'+ ' '+ getStatusClass(ticketDetail)">-->
        <!--                                                    <div></div>-->

        <!--                                                </div>-->
        <!--                                                <span :class="'indicate-dot-text ' +' '+getStatusClass(ticketDetail)">-->
        <!--                            <span v-if=" getStatusClass(ticketDetail) == 'paid'">{{$t("cTicketingDetail.ticketed")}}</span>-->
        <!--                            <span v-if=" getStatusClass(ticketDetail) == 'unpaid'&&ticketDetail.orderStatus!=15">{{$t("cTicketingDetail.failed")}}</span>-->
        <!--                           <span v-if=" getStatusClass(ticketDetail) == 'partial_paid'">{{$t("cTicketingDetail.hold")}}</span>-->
        <!-- <span v-if=" getStatusClass(ticketDetail) == 'unpaid'&&ticketDetail.orderStatus==15">{{$t("cTicketingDetail.cancelled")}}</span>-->
        <!--                       </span>-->


        <!--                                                &lt;!&ndash; <div class="indicate-dot partial_paid">-->
        <!--                                                  <div></div>-->
        <!--                                                </div>-->
        <!--                                                <span class="indicate-dot-text partial_paid">-->
        <!--                                                  <span>Hold</span>-->
        <!--                                                </span> &ndash;&gt;-->
        <!--                                            </div>-->
        <!--                                        </div>-->
        <!--                                    </div>-->
        <!--                                    <div class="details-wrap">-->
        <!--                                        <div class="wrap">-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.reservationId")}}</div>-->
        <!--                                                <div class="value" v-if="ticketDetail.orderID">-->
        <!--                                                    {{ticketDetail.orderID}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details"-->
        <!--                                                 v-if="checkByOrderStatus(ticketDetail)&&ticketRowObj&&ticketRowObj.ticketingdeadline">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.ticketingDeadline")}}-->
        <!--                                                </div>-->
        <!--                                                <div class="value">{{ticketRowObj.ticketingdeadline |-->
        <!--                                                    formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.pnr")}}</div>-->
        <!--                                                <div class="value" v-for="(pnr,index) in ticketDetail.pnr"-->
        <!--                                                     :key="index">-->
        <!--                                                    {{pnr}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.dateOfBooking")}}</div>-->
        <!--                                                <div class="value" v-if="ticketDetail.bookingDate">-->
        <!--                                                    {{ticketDetail.bookingDate|formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            &lt;!&ndash; <div class="details">-->
        <!--                                              <div class="title">Date of Booking</div>-->
        <!--                                              <div class="value">24-Jan-2020 18:08:22</div>-->
        <!--                                            </div> &ndash;&gt;-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.travelDate")}}</div>-->

        <!--                                                <div class="value" v-if="ticketDetail.flights-->
        <!--                        ">-->

        <!--                                                    <div v-for="(flightObj,index) in ticketDetail.flights"-->
        <!--                                                         :key="index">-->
        <!--                                                        {{flightObj.flight.DepDate|formatDateTime("DD-MMM-YYYY-->
        <!--                                                        HH:mm")}}-->
        <!--                                                    </div>-->
        <!--                                                </div>-->

        <!--                                                <div class="value" v-if="ticketDetail.journeyType==2">-->
        <!--                                                    {{ticketDetail.flights[ticketDetail.flights.length-1].flight.ArrDate|formatDateTime("DD-MMM-YYYY-->
        <!--                                                    HH:mm")}}-->
        <!--                                                </div>-->

        <!--                                            </div>-->
        <!--                                            <div class="details" v-if="!checkHoldByOrderStatus(ticketDetail)">-->
        <!--                                                <div class="title">Ticket Number</div>-->
        <!--                                                <div class="ticket-loop-pl-0">-->
        <!--                                                    <div class="d-flex flex-flow-wrap">-->
        <!--                                                        <div class="col-6 "-->
        <!--                                                             v-for="(tickNumbers,index) in ticketDetail.ticketNumbers"-->
        <!--                                                             :key="index">-->
        <!--                                                            <div class="d-flex">-->
        <!--                                                                {{tickNumbers}} <span-->
        <!--                                                                    v-if="ticketDetail.ticketNumbers.length >= 2">,</span>-->
        <!--                                                            </div>-->

        <!--                                                        </div>-->
        <!--                                                        <div v-if="ticketDetail&&ticketDetail.ticketNumbers&&ticketDetail.ticketNumbers.length==0">-->
        <!--                                                            - -->
        <!--                                                        </div>-->
        <!--                                                    </div>-->


        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.bookBy")}}</div>-->
        <!--                                                <div class="value" v-if="ticketRowObj&&ticketRowObj.agencyname">-->
        <!--                                                    {{ticketRowObj.agencyname}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details" v-if="ticketDetail&&ticketDetail.orderStatus==15">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.cancelledDate")}}</div>-->
        <!--                                                <div class="value" v-if="ticketDetail&&ticketDetail.cancelDate">-->
        <!--                                                    {{ticketDetail.cancelDate|formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS)}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details" v-if="ticketDetail&&ticketDetail.ticketissueDate">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.issuedDate")}}</div>-->
        <!--                                                <div class="value">-->
        <!--                                                    {{ticketDetail.ticketissueDate|formatDateTime("DD-MMM-YYYY-->
        <!--                                                    HH:mm")}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                        </div>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </CCol>-->
        <!--                        <CCol md="8">-->
        <!--                            <div class="c-wrap">-->
        <!--                                <div class="pay-title">{{$t("cTicketingDetail.flightDetails")}}</div>-->
        <!--                                <div class="flight-details">-->
        <!--                                    <table>-->
        <!--                                        <thead class="trip-wrap">-->
        <!--                                        <tr class="route-details" v-for="(flightObj,index) in ticketDetail.flights"-->
        <!--                                            :key="index">-->
        <!--                                            <th>-->
        <!--                                                <div class="logo">-->

        <!--                                                    <img-->
        <!--                                                            v-if="ticketDetail.airlines"-->
        <!--                                                            :src="ticketDetail.airlines[flightObj.flight.opAirline].logourl"-->
        <!--                                                            :onerror="defaultALImg" width="40px"-->
        <!--                                                    />-->
        <!--                                                </div>-->
        <!--                                            </th>-->
        <!--                                            <th>-->
        <!--                                                <div class="route">-->
        <!--                                                    <div class="route-form-to" v-if="flightObj.flight.DepAirport">-->
        <!--                                                        {{ticketDetail.airports[flightObj.flight.DepAirport].city}}-->
        <!--                                                    </div>-->
        <!--                                                    <div class="airport-name" v-if="flightObj.flight.DepAirport">-->
        <!--                                                        {{ticketDetail.airports[flightObj.flight.DepAirport].airportname}}-->
        <!--                                                    </div>-->
        <!--                                                    <div class="time">-->
        <!--                                                        <div class="bold" v-if="flightObj.flight.DepDate">-->
        <!--                                                            {{flightObj.flight.DepDate|formatDate("HH:mm")}}-->
        <!--                                                        </div>-->
        <!--                                                        <span class="bold">-->
        <!--                            - -->
        <!--                          </span>-->
        <!--                                                        <div class="date" v-if="flightObj.flight.DepDate">-->
        <!--                                                            {{flightObj.flight.DepDate|formatDate}}-->
        <!--                                                        </div>-->
        <!--                                                    </div>-->
        <!--                                                </div>-->
        <!--                                            </th>-->
        <!--                                            <th>-->
        <!--                                                <div class="trip-logo">-->
        <!--                                                    <img-->
        <!--                                                            src="@imgPath/img/svg/icons/flight-black.svg"-->
        <!--                                                            width="20px"-->
        <!--                                                            alt-->
        <!--                                                    />-->
        <!--                                                </div>-->
        <!--                                            </th>-->
        <!--                                            <th>-->
        <!--                                                <div class="route">-->
        <!--                                                    <div class="route-form-to" v-if="flightObj.flight.ArrAirport">-->
        <!--                                                        {{ticketDetail.airports[flightObj.flight.ArrAirport].city}}-->
        <!--                                                    </div>-->
        <!--                                                    <div class="airport-name" v-if="flightObj.flight.ArrAirport">-->
        <!--                                                        {{ticketDetail.airports[flightObj.flight.ArrAirport].airportname}}-->
        <!--                                                    </div>-->
        <!--                                                    <div class="time">-->
        <!--                                                        <div class="bold" v-if="flightObj.flight.ArrDate">-->
        <!--                                                            {{flightObj.flight.ArrDate|formatDate("HH:mm")}}-->
        <!--                                                        </div>-->
        <!--                                                        <span class="bold">-->
        <!--                            - -->
        <!--                          </span>-->
        <!--                                                        <div class="date" v-if="flightObj.flight.ArrDate">-->
        <!--                                                            {{flightObj.flight.ArrDate|formatDate("DD-MMM-YYYY")}}-->
        <!--                                                        </div>-->
        <!--                                                    </div>-->
        <!--                                                </div>-->
        <!--                                            </th>-->
        <!--                                            <th>-->
        <!--                                                <div class="details ml-10px">-->
        <!--                                                    <div>-->
        <!--                                                        {{ticketDetail.airlines[flightObj.flight.opAirline].airline_name-->
        <!--                                                        }}-->
        <!--                                                        &lt;!&ndash; {{$t('flightResults.airlines')}} &ndash;&gt;-->
        <!--                                                    </div>-->
        <!--                                                    <div>-->
        <!--                                                        &lt;!&ndash;                                    <span>{{selflightObj.ib.ibFlight[0].flight.opAirline+' | '+selflightObj.ib.ibFlight[0].flight.FlightNo}}</span>&ndash;&gt;-->
        <!--                                                        <span>{{flightObj.flight.FlightNo}}</span>-->
        <!--                                                        |-->
        <!--                                                        &lt;!&ndash; <span>Boeing 787</span>| &ndash;&gt;-->
        <!--                                                        <span>Class {{flightObj.flight.Bookingclass}}</span>-->
        <!--                                                    </div>-->


        <!--                                                </div>-->
        <!--                                            </th>-->

        <!--                                        </tr>-->
        <!--                                        </thead>-->
        <!--                                    </table>-->

        <!--                                </div>-->
        <!--                            </div>-->
        <!--                            <div class="w-100">-->
        <!--                                <div class="passenger-details" v-if="ticketDetail.orderPassengerDetails">-->
        <!--                                    <div class="c-wrap passenger-det">-->
        <!--                                        <div class="pay-title">{{$t("cTicketingDetail.passengerDetails")}}</div>-->
        <!--                                        <div class="pass-wrap"-->
        <!--                                             v-for="(passengerDetail,index) in ticketDetail.orderPassengerDetails"-->
        <!--                                             :key="index">-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.name")}}</div>-->
        <!--                                                <div class="value">{{passengerDetail.firstName+'-->
        <!--                                                    '}}{{passengerDetail.lastName}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.gender")}}</div>-->
        <!--                                                <div class="value">-->
        <!--                                                    {{passengerDetail.Gender==1?$t("cTicketingDetail.male"):$t("cTicketingDetail.female")}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.idNumber")}}</div>-->
        <!--                                                <div class="value">{{passengerDetail.idNumber}}</div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.dob")}}</div>-->
        <!--                                                <div class="value">-->
        <!--                                                    {{passengerDetail.dateOfBirth|formatDate}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="details">-->
        <!--                                                <div class="title">{{$t("cTicketingDetail.nationality")}}</div>-->
        <!--                                                <div class="value">{{passengerDetail.nationality_name}}</div>-->
        <!--                                            </div>-->

        <!--                                        </div>-->

        <!--                                    </div>-->
        <!--                                </div>-->

        <!--                            </div>-->
        <!--                        </CCol>-->
        <!--                        <CCol md="4">-->
        <!--                            <div class="c-wrap h-100">-->
        <!--                                <div class="pay-title pl-0px">{{$t("cTicketingDetail.paymentDetails")}}</div>-->
        <!--                                <div class="payment-details">-->
        <!--                                    <div class="wrap">-->
        <!--                                        <div class="details-wrap">-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.status")}}</div>-->
        <!--                                                <div v-if="ticketDetail.orderStatusString">-->
        <!--                                                    {{ticketDetail.orderStatusString}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.userId")}}</div>-->
        <!--                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].userName">-->
        <!--                                                    {{ticketDetail.orderPaymentDetails[0].userName}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.transactionId")}}</div>-->
        <!--                                                <div v-if="ticketDetail.transactionId">-->
        <!--                                                    {{ticketDetail.transactionId}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.paymentType")}}</div>-->
        <!--                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].paymentType">-->
        <!--                                                    {{ticketDetail.orderPaymentDetails[0].paymentType}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.approvalCode")}}</div>-->

        <!--                                            </div>-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.currency")}}</div>-->

        <!--                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].currency">-->
        <!--                                                    {{ticketDetail.orderPaymentDetails[0].currency}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.orderAmt")}}</div>-->
        <!--                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].OrderAmount">-->
        <!--                                                    {{ticketDetail.orderPaymentDetails[0].OrderAmount}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.paymentFee")}}</div>-->
        <!--                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].PaymentFee">-->
        <!--                                                    {{ticketDetail.orderPaymentDetails[0].PaymentFee}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                            <div class="d-flex">-->
        <!--                                                <div>{{$t("cTicketingDetail.totalAmt")}}</div>-->
        <!--                                                <div v-if="ticketDetail.orderPaymentDetails[0]&&ticketDetail.orderPaymentDetails[0].TotalAmount">-->
        <!--                                                    {{ticketDetail.orderPaymentDetails[0].TotalAmount}}-->
        <!--                                                </div>-->
        <!--                                            </div>-->
        <!--                                        </div>-->
        <!--                                    </div>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </CCol>-->
        <!--                        <CButton @click="navigateToPrevPage"-->
        <!--                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger">-->
        <!--                <span>-->
        <!--                        {{ $t('cTicketingDetail.goBackBtn') }}-->
        <!--                </span>-->
        <!--                        </CButton>-->
        <!--                        <CButton @click="emitNav(ticketRowObj)"-->
        <!--                                 v-if="AGENT_SIGNIN_RES&&checkByOrderStatus(ticketDetail)&&!isBooking"-->
        <!--                                 class="btn align-right btn-lit-blue btn-success mt-10px mr-10px ml-auto">-->
        <!--                <span>-->
        <!--                        {{ $t('ticketingQueue.tcktNow') }}-->
        <!--                </span>-->
        <!--                        </CButton>-->
        <!--                        <CButton v-if="AGENT_SIGNIN_RES&&checkHoldByOrderStatus(ticketDetail)&&!isBooking"-->
        <!--                                 @click.stop="onShowCancelConfirmation(ticketRowObj)"-->
        <!--                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger">-->
        <!--                <span>-->
        <!--                        {{ $t('ticketingQueue.cancelBtn') }}-->
        <!--                </span>-->
        <!--                        </CButton>-->
        <!--                    </CRow>-->
        <!--                </div>-->


        <!--            </div>-->
        <!--            &lt;!&ndash;      <div class="booking-full-details-back-drop"></div>&ndash;&gt;-->
        <!--        </div>-->

        <cAlertModal v-if="isShowCancelAlert"
                     :buttonList="[{
              name:$t('ticketingQueue.noBtn'),func:onRejectCancel,color:'danger'},
                {name:$t('ticketingQueue.yesBtn'),func:onCancelBooking,color:'success'},]"
                     :status="2"
                     :show="isShowCancelAlert"
                     :desc="$t('ticketingQueue.cancelConfirmation')"

        ></cAlertModal>

        <cAlertModal v-if="isBookCancelledAlert"
                     :buttonList="[
                {name:$t('ticketingQueue.okBtn'),func:onHideCancelledAlert,color:'success'},]"
                     :status="1"
                     :show="isBookCancelledAlert"
                     :desc="[$t('ticketingQueue.cancelBookingSuccessdesc'),
            selBookingDetail.orderid?$t('ticketingQueue.reservationId')+': '+selBookingDetail.orderid:''
            ]"


        ></cAlertModal>
<cAlertModal v-if="isRetryPaymentAlert" :key="'alertModal'+2"
                     :buttonList="[{
              name:$t('ticketingQueue.noBtn'),func:onHideRetryModal,color:'danger'},
                {name:$t('ticketingQueue.yesBtn'),func:onRetryPayment,color:'success'},]"
                     :status="2"
                     :show="isRetryPaymentAlert"
                     :desc="[$t('ticketingQueue.retryPaymentModalDesc1'),$t('ticketingQueue.retryPaymentModalDesc2')]"

        ></cAlertModal>
        <CAlert v-if="alertValue" show color="danger">
            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p v-for="(value,index) in alertValue.valueList" :key="index">
                    {{value}}
                </p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                <span>{{$t("cAlert.errorCode")+' : '}}</span><span v-for="(code,index) in alertValue.codeList"
                                                                   :key="index">
                        {{code +' '}}
                      </span>
            </div>
            <div v-if="alertValue&&alertValue.constructor==String">
                <p>
                    {{alertValue}}
                </p>
            </div>
        </CAlert>


    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";

    import {
        COMPONENT_NAME,
        PATHNAME,
        TRIP,
        DEFAULT_DROPDOWN_STATUS,
        ALERT_MODAL_STATUS,
        BOOKING_STATUS,DATE_TIME_FORMAT,
        ORDER,
        BOOKING_ORDER_TYPE
    } from "../../util/constants";
    import cAlertModal from "../../components/form/cAlertModal";
    import apiGetOrderDetailsForView from "../../services/apiGetOrderDetailsForView";
    import BaseConfiguration from "../../config/base";
    import apiCancelBooking from "../../services/apiCancelBooking";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import {
        handleJWT,
        getErrorAlertValue,
        cloneData,
        removeDuplicates,
        OrderByList,
        GroupByList,
  OrderBy,
        scrollToBottom
    } from "../../util/util";
    import Logger from "../../services/logger";
    import apiGetRoutes from "../../services/apiGetRoutes.js";
    import router, {navigate, goBack} from "../../router/index";
    import apiGetTicketingQueueList from "../../services/apiGetTicketingQueueList";
     import apiRefundRequested from '../../services/apiRefundRequested'
 //   import cConnectingFlightDetail from "./cConnectingFlightDetail";
    import cTicketingConnectionFlight from "./cTicketingConnectionFlight";


    export default {
        name: COMPONENT_NAME.C_TICKETING_DETAIL,

        components: {

            cAlertModal,
            cTicketingConnectionFlight
        },
        props: {
            ticketingDetail: {
                type: Object | Array,
                default: null
            },
            isBooking: {
                type: Boolean,
                default: false
            },
        },
        computed: {

               DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
            ...mapGetters("sTicketingQueue", {
                ticketRowObj: "GET_TICKETING_QUEUE"
            }),
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
            ...mapGetters("sAgtLogin", {
                AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
            }),
            ...mapGetters("sDashBoard", {
                AGENT_DET: "GET_AGENT_LOGO_DET_RES"
            }),
            ...mapGetters("cBookingDetail", {
                GET_BOOKING_SEARCH_OBJ: "GET_FILTER_SEARCH_OBJ",

                // GET_BOOKING_ROUTE:"GET_FILTER_ROUTE",
                // GET_BOOKING_LIST_RES:"GET_BOOKING_LIST_RES"

            }),
            ...mapGetters("cTicketingDetail", {
                GET_TICKETING_SEARCH_OBJ: "GET_FILTER_SEARCH_OBJ",
                // GET_BOOKING_ROUTE:"GET_FILTER_ROUTE",
                // GET_BOOKING_LIST_RES:"GET_BOOKING_LIST_RES"

            }),

        },
        data() {
            return {
                tcktDetLs:null,
                ticketDetail: null,
                alertValue: null,
                selBookingDetail: null,
                isShowCancelAlert: null,
                isBookCancelledAlert: false,
                defaultALImg: BaseConfiguration.defaultALImg,
                cancelledbookRes: null,
                isHighLight: false,
                isShowMore: false,
                isStopsForNonMyanmar:BaseConfiguration.isStopsForNonMyanmar,
                isRetryPaymentAlert:false
            };
        },

        methods: {
            ...mapActions("sCSearch", {

                SET_ROUTES_OBJ: "SET_ROUTES_OBJ",

            }),
            ...mapActions("cBookingDetail", {
                SET_FILTER_SEARCH_OBJ: "SET_FILTER_SEARCH_OBJ",
                SET_BOOKING_LIST_RES: "SET_BOOKING_LIST_RES",
                SET_TKT_REFUND_OBJ:"SET_TKT_REFUND_OBJ",
                SET_TKT_EXCHANGE_OBJ:"SET_TKT_EXCHANGE_OBJ"

            }),
            ...mapActions("cTicketingDetail", {
                //  SET_FILTER_SEARCH_OBJ: "SET_FILTER_SEARCH_OBJ",
                SET_TICKETING_QUEUE_RES: "SET_TICKETING_QUEUE_RES"
            }),










           




  navToExchange(pTicketObj)
    {
 
         try {
           if(BaseConfiguration.isDebug) console.log("navToExchange");


           if(pTicketObj)
           {
          this.SET_TKT_EXCHANGE_OBJ(pTicketObj);
          navigate(PATHNAME.EXCHANGE)
           }
             else
           {
               throw 'Invalid Ticket Object '
           }
         } catch (err) {
                 let body = Logger.buildRequest(
                   FILE_NAME.C_TICKETING_DETAIL,
                   "error in navToExchange",
                   err.toString(),
                   "navToExchange",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
         
         
    },

             showConnectingFlights() {
      if (BaseConfiguration.isDebug) console.log("showConnectingFlights");

      this.isShowMore = !this.isShowMore;
    },






     navToRefund(pTicketObj)
    {
 
         try {
           if(BaseConfiguration.isDebug) console.log("navToRefund");

                 
            if(pTicketObj)
           {
          this.SET_TKT_REFUND_OBJ(pTicketObj);
          navigate(PATHNAME.REFUND)
           }
           else
           {
               throw 'Invalid Ticket Object '
           }
           
         } catch (err) {
                 let body = Logger.buildRequest(
                   FILE_NAME.C_TICKETING_DETAIL,
                   "error in navToRefund",
                   err.toString(),
                   "navToRefund",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
         
         
    },

          





             getExchangeStatus(pTicket) {
         let retValue=false;

          try {
            if(BaseConfiguration.isDebug) console.log("getExchangeStatus");


            if(pTicket && pTicket.status && pTicket.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER)
            {
             retValue= (pTicket.status==   BOOKING_STATUS.TICKETED_SUCCESS_STATUS) || (pTicket.status==BOOKING_STATUS.TICKET_PENDING);
             
            }


      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_TICKETING_DETAIL,
                    "error in getExchangeStatus",
                    err.toString(),
                    "getExchangeStatus",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 


     getRefundStatus(pTicket) {
         let retValue=false;

          try {
            if(BaseConfiguration.isDebug) console.log("getRefundStatus");


            if(pTicket && pTicket.status && pTicket.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER)
            {
             retValue= (pTicket.status==   BOOKING_STATUS.TICKETED_SUCCESS_STATUS) || (pTicket.status==BOOKING_STATUS.TICKET_PENDING);
             
            }


      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_TICKETING_DETAIL,
                    "error in getRefundStatus",
                    err.toString(),
                    "getRefundStatus",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 


            showTktNumbers() {

                var el = null;

                el = this.$refs.paxtable;


                if (el) {
                    el.scrollIntoView({behavior: 'smooth'});
                }
                /*var objDiv = document.getElementById("paxtable");
                objDiv.scrollTop = objDiv.scrollHeight;*/
                //scrollToBottom();
                this.isHighLight = true;
                let that = this;
                setTimeout(function () {
                    that.isHighLight = false;
                }, 1000);

            },
            emitNav(item) {
                this.$emit("navFromDetail", item);
            },
             onShowRetryPayModel(pItem) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onShowRetryPayModel");
                                      this.selBookingDetail=pItem;

                    this.isRetryPaymentAlert=true;
                    
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onShowRetryPayModel",
                        err.toString(),
                        "onShowRetryPayModel",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            navigateToPrevPage() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navigateToPrevPage");

                    goBack();
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_DETAIL,
                        "error in navigateToPrevPage",
                        err.toString(),
                        "navigateToPrevPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            onRetryPayment() {
                try {
                  if(BaseConfiguration.isDebug) console.log("onRetryPayment");
               this.isRetryPaymentAlert=false;
               this.emitNav(this.selBookingDetail)
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_TICKETING_DETAIL,
                          "error in onRetryPayment",
                          err.toString(),
                          "onRetryPayment",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                }, 
 onHideRetryModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onHideRetryModal");
                  
                    this.isRetryPaymentAlert = false;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in onHideRetryModal",
                        err.toString(),
                        "onHideRetryModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            onHideCancelledAlert() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onHideCancelledAlert");
                    // this.isBookCancelledAlert=false;
                    navigate(PATHNAME.TICKETING_QUEUE);
                    this.isBookCancelledAlert = false;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in onHideCancelledAlert",
                        err.toString(),
                        "onHideCancelledAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            //         async getBookingList(bookingObj) {
            //   try {
            //     if (BaseConfiguration.isDebug) console.log("getBookingList");
            //     //let retValue;
            //     //let bookingList;
            //     // this.SET_FILTER_SEARCH_OBJ(bookingObj);
            //     if(this.AGENT_SIGNIN_RES && this.AGENT_DET){
            //       bookingObj.b2bid = this.AGENT_DET.b2bid;
            //     }
            //     let bookingReq = apiGetMyBookingsList.buildRequest(bookingObj);

            //     if (bookingReq) {
            //       let bookingRes = await apiGetMyBookingsList.getResponse(bookingReq);
            //       if (VALIDATE_SUCCESS_RES(bookingRes)) {
            //         this.SET_BOOKING_LIST_RES(bookingRes.data.data)

            //         // this.showAcknowledgeAlert();
            //       } else {
            //         let error = getErrorMessage(bookingRes);
            //         let isJwt = handleJWT(error);
            //         if (!isJwt) {
            //           getErrorAlertValue(error);
            //         }
            //       }
            //     } else {
            //       throw "invalid request";
            //     }

            //     //return bookingList;
            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       COMPONENT_NAME.C_TICKETING_DETAIL,
            //       "error in getBookingList",
            //       err.toString(),
            //       "getBookingList",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            //   // return retValue;
            // },
            async getTicketingQueueList(ticketingObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getTicketingQueueList");
                    //let retValue;
                    //let TicketQList;
                    // if(this.AGENT_SIGNIN_RES && this.AGENT_DET){
                    //   ticketingObj.b2bid = this.AGENT_DET.b2bid;
                    // }
                    let ticketQReq = apiGetTicketingQueueList.buildRequest(ticketingObj);

                    if (ticketQReq) {
                        let ticketQRes = await apiGetTicketingQueueList.getResponse(
                            ticketQReq
                        );
                        if (VALIDATE_SUCCESS_RES(ticketQRes)) {
                            let ticketingQueueResponse = ticketQRes.data.data.bookings;
                            this.SET_TICKETING_QUEUE_RES(ticketQRes.data.data)

                            //  this.statusCount=ticketQRes.data.data.statusCount;
                            //    ticketingQueueResponse = OrderByList(ticketingQueueResponse,'ticketingdeadline','desc');
                            // this.ticketingQueueList = cloneData(ticketingQueueResponse);
                            //         this.jsonData = this.getJsonData(ticketingQueueResponse);
                            //                      this.ticketingQueueList = null;

                            //                   let that = this;
                            // Vue.nextTick(() => {///for a smooth update
                            //                        this.ticketingQueueList = ticketingQueueResponse;
                            //                     });

                            // this.showAlert(null);
                            // this.showAcknowledgeAlert();
                        } else {
                            let error = getErrorMessage(ticketQRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }

                    //return TicketQList;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.TICKETING_QUEUE,
                        "error in getTicketingQueueList",
                        err.toString(),
                        "getTicketingQueueList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },


            async onCancelBooking() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onCancelBooking");
                       this.isShowCancelAlert = false;

                    let retCancelledbookRes = await this.getCancelBooking(this.selBookingDetail.orderId);
                 
                    if (retCancelledbookRes) {
                        this.isBookCancelledAlert = true;
                        this.cancelledbookRes = retCancelledbookRes;
                        if (this.GET_TICKETING_SEARCH_OBJ) {
                            //  this.getBookingList(this.GET_BOOKING_SEARCH_OBJ);
                            this.getTicketingQueueList(this.GET_TICKETING_SEARCH_OBJ)

                        }
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in onCancelBooking",
                        err.toString(),
                        "onCancelBooking",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            onRejectCancel() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onRejectCancel");
                    this.isShowCancelAlert = false;
                    if (this.cancelledbookRes && this.isBookCancelledAlert) {

                        navigate(PATHNAME.TICKETING_QUEUE);
                        this.isBookCancelledAlert = false;

                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in onRejectCancel",
                        err.toString(),
                        "onRejectCancel",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            async getCancelBooking(pOrderId) {
                let returnValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getCancelBooking");
                    let cancelBookingReq = apiCancelBooking.buildRequest(pOrderId);
                    if (cancelBookingReq) {
                        let cancelBookingRes = await apiCancelBooking.getResponse(cancelBookingReq);

                        if (VALIDATE_SUCCESS_RES(cancelBookingRes)) {//VALIDATE_SUCCESS_RES(cancelBookingRes)
                            returnValue = cancelBookingRes.data.data;
                        } else {
                            let error = getErrorMessage(cancelBookingRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                getErrorAlertValue(error);
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in getCancelBooking",
                        err.toString(),
                        "getCancelBooking",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;

            },


            onShowCancelConfirmation(pItem) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onShowCancelConfirmation");
                    this.selBookingDetail = pItem;
                    this.isShowCancelAlert = true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in onShowCancelConfirmation",
                        err.toString(),
                        "onShowCancelConfirmation",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            checkStatus(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("checkStatus");
                    let retValue;
                    if (pStatus) {

                        if (pStatus.bookingStatus == BOOKING_STATUS.TICKETED_SUCCESS)
                            retValue = false;
                        else
                            retValue = true;

                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in checkStatus",
                        err.toString(),
                        "checkStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },
            checkHoldByOrderStatus(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("checkHoldByOrderStatus");
                    let retValue;
                    if (pStatus) {

                        if (pStatus.orderStatus == BOOKING_STATUS.HOLD_STATUS)
                            retValue = true;
                        else
                            retValue = false;

                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in checkHoldByOrderStatus",
                        err.toString(),
                        "checkHoldByOrderStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },
            checkByOrderStatus(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("checkByOrderStatus");
                    let retValue;
                    if (pStatus) {

                        if (pStatus.orderStatusString == BOOKING_STATUS.TICKETED_SUCCESS)
                            retValue = false;
                        else
                            retValue = true;

                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in checkByOrderStatus",
                        err.toString(),
                        "checkByOrderStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },
            getStatusClsByBookStatus(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatusClsByBookStatus");
                    let retValue;
                    if (pStatus && pStatus.bookingStatus) {
                        if (pStatus.bookingStatus == BOOKING_STATUS.HOLD) {
                            retValue = 'partial_paid'
                        } else if (pStatus.bookingStatus == BOOKING_STATUS.TICKETED_SUCCESS) {
                            retValue = 'paid'
                        } else if (pStatus.status == BOOKING_STATUS.TICKET_PENDING) {
                            retValue = 'unpaid'
                        } else if (pStatus.status == BOOKING_STATUS.BOOKING_CANCELLED) {
                            retValue = 'unpaid'
                        }
                          else if(pStatus.status == BOOKING_STATUS.REFUND_REQUESTED) 
         {

           retValue ="partial_paid"
         }
                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in getStatusClsByBookStatus",
                        err.toString(),
                        "getStatusClsByBookStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },
            getCancelBtnStatus(pTicketItem) {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getCancelBtnStatus");
                    if (pTicketItem && pTicketItem.orderStatus) {
                        if (pTicketItem.orderStatus == BOOKING_STATUS.HOLD_STATUS ||
                            pTicketItem.orderStatus == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = true;
                        } else {
                            retValue = false;
                        }
                    } else {
                        retValue = false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_DETAIL,
                        "error in getCancelBtnStatus",
                        err.toString(),
                        "getCancelBtnStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getRetryBtnStatus(pTicketItem) {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getRetryBtnStatus");
                    if (pTicketItem && pTicketItem.orderStatus) {
                        if (pTicketItem.orderStatus == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = true;
                        } else {
                            retValue = false;
                        }
                    } else {
                        retValue = false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_DETAIL,
                        "error in getRetryBtnStatus",
                        err.toString(),
                        "getRetryBtnStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getStatusClass(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatusClass");
                    let retValue;
                    if (pStatus && pStatus.orderStatus) {
                        if (pStatus.orderStatus == BOOKING_STATUS.HOLD_STATUS) {
                            retValue = 'partial_paid'
                        } else if (pStatus.orderStatus == BOOKING_STATUS.TICKETED_SUCCESS_STATUS) {
                            retValue = 'paid'
                        } else if (pStatus.orderStatus == BOOKING_STATUS.TICKET_PENDING) {
                            retValue = 'unpaid'
                        } else if (pStatus.orderStatus == BOOKING_STATUS.BOOKING_CANCELLED) {
                            retValue = 'unpaid'
                        } else if (pStatus.orderStatus == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = 'unpaid'
                        }
                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in getStatusClass",
                        err.toString(),
                        "getStatusClass",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getPassengerCount(pPax) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPassengerCount");
                    //let retValue;
                    let paxCount = 0;
                    if (pPax) {
                        if (pPax.adultscount)
                            paxCount = paxCount + pPax.adultscount;
                        if (pPax.childcount)
                            paxCount = paxCount + pPax.childcount;
                        if (pPax.infantcount)
                            paxCount = paxCount + pPax.infantcount
                    }
                    if (paxCount > 1)
                        paxCount = paxCount;
                    else
                        paxCount = paxCount;
                    return paxCount;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in getPassengerCount",
                        err.toString(),
                        "getPassengerCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },
            getTripDisPlayText(pJourneyType) {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getTripDisPlayText");

                    if (pJourneyType == 1) {
                        retValue = this.$t("cTicketingDetail.oneWay");
                    } else if (pJourneyType == 2) {
                        retValue = this.$t("cTicketingDetail.roundTrip");

                    } else if (pJourneyType == 3) {
                        retValue = this.$t("cTicketingDetail.multiCity");

                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in getTripDisPlayText",
                        err.toString(),
                        "getTripDisPlayText",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getPassDisplayText(pPassengerCount) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getPassDisplayText");
                    if (Number(pPassengerCount) == 1) {
                        retValue = this.$t("cTicketingDetail.passenger");
                    } else if (Number(pPassengerCount) > 1) {
                        retValue = this.$t("cTicketingDetail.passengers");

                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_DETAIL,
                        "error in getPassDisplayText",
                        err.toString(),
                        "getPassDisplayText",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            emitClose() {
                this.$emit("close");
            },

            showAlert(val) {
                this.alertValue = val;
            },

            async getTicketingOrderDetails(ptcktObj) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTicketingOrderDetails");
                    if (ptcktObj) {
                        let orderId = ptcktObj.orderId;

                        let tcktRequest = apiGetOrderDetailsForView.buildRequest(orderId);

                        if (tcktRequest) {
                            let tcktResponse = await apiGetOrderDetailsForView.getResponse(
                                tcktRequest
                            );
                            if (VALIDATE_SUCCESS_RES(tcktResponse)) {
                                retValue = tcktResponse.data.data;
                                // this.toggleShowTicketingDetail();
                                this.showAlert(null);
                            } else {
                                let error = getErrorMessage(tcktResponse);
                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.showAlert(getErrorAlertValue(error));
                                }
                            }
                        } else {
                            throw "invalid request";
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_DETAIL,
                        "error in getTicketingOrderDetails",
                        err.toString(),
                        "getTicketingOrderDetails",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            ///to get number of routes response from api
            async getRoutesResponse() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

                    let getRoutesRequest = apiGetRoutes.buildRequest();

                    if (getRoutesRequest) {
                        // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
                        let getRouteResponse = await apiGetRoutes.getResponse(
                            getRoutesRequest
                        );

                        if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
                            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store

                            retValue = getRouteResponse.data.data;
                            this.SET_ROUTES_OBJ(retValue);
                        } else {
                            let error = getErrorMessage(getRouteResponse);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SEARCH,
                        "error while getting response from get Routes response API",
                        err.toString(),
                        "getRoutesResponse",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            moveLeadPaxToFirst(pTicketDetail) {
                let retValue = pTicketDetail;

                try {

                    if (BaseConfiguration.isDebug) console.log("moveLeadPaxToFirst");
                    let paxList = [];
                    for (let i = 0; i < pTicketDetail.orderPassengerDetails.length; i++) {
                        if (pTicketDetail.orderPassengerDetails[i].isLeadPax) {
                            if (i == 0) {

                                return retValue;
                            }
                            paxList.push(pTicketDetail.orderPassengerDetails[i]);
                            break;
                        }
                    }
                    for (let j = 0; j < pTicketDetail.orderPassengerDetails.length; j++) {
                        if (!pTicketDetail.orderPassengerDetails[j].isLeadPax) {
                            paxList.push(pTicketDetail.orderPassengerDetails[j]);

                        }
                    }
                    retValue.orderPassengerDetails = paxList;

//                         pTicketDetail.orderPassengerDetails.splice(sourceIndex, 1) 
//   array.splice(targetIndex, 0, object) 

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_DETAIL,
                        "error in myFunctionName",
                        err.toString(),
                        "myFunctionName",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },









             async getRequestedRefundList(pOrderId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRequestedRefundList");

        if (pOrderId) {
          let refundReq = apiRefundRequested.buildRequest(pOrderId);

          if (refundReq != null) {
            let refundRes = await apiRefundRequested.getResponse(refundReq);

            if (VALIDATE_SUCCESS_RES(refundRes)) {
              retValue = refundRes.data.data;
            } else {
              let error = getErrorMessage(refundRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          } else {
            throw "invallid Req";
          }
        } else {
          throw " invalid  OrderId ";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_TICKETING_DETAIL,
          "error in getRequestedRefundList",
          err.toString(),
          "getRequestedRefundList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);zz
      }
      return retValue;
    },
   getFlightListByGroup(pTicketDetail) {
      let flightGroupList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getFlightListByGroup");
        if (
          pTicketDetail &&
          pTicketDetail.flights &&
          pTicketDetail.flights.length > 0
        ) {
          flightGroupList = GroupByList(
            pTicketDetail.flights,
            "id",
            "flightGroup"
          );
        }

        if (flightGroupList.length > 0) {
          for (let index = 0; index < flightGroupList.length; index++) {
            const flight = flightGroupList[index];
            // flight.flightGroup.forEach(element => {
            //   element.flight.via = { text: "via" + index };
            // });
            flight.flightGroup = OrderBy(
              flight.flightGroup,
              "displayOrder",
              ORDER.ASC
            );
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_TICKETING_CONNECTION_FLIGHT,
          "error in getFlightListByGroup",
          err.toString(),
          "getFlightListByGroup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return flightGroupList;
},
     getStops(pFlightList) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getStops");

        if (pFlightList && pFlightList.length > 1) {
          retValue = pFlightList.length - 1 + "" + "Stop";
        } 
        else {
            // retValue = "Non-Stop";
        //   if (BaseConfiguration.isStopsForNonMyanmar && pFlightList.length == 1) {
        //     retValue = pFlightList[0].flight.via
        //       ? pFlightList[0].flight.via.text.split(",").length + " Stop"
        //       : "Non-Stop";
        //   } else retValue = "Non-Stop";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_TICKETING_CONNECTION_FLIGHT,
          "error in getStops",
          err.toString(),
          "getStops",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getVia(pFlightList) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getVia");

        if (BaseConfiguration.isStopsForNonMyanmar && pFlightList) {
          let viaText = "";
          for (let index = 0; index < pFlightList.length; index++) {
            const flight = pFlightList[index];
            viaText += flight.flight.via ? flight.flight.via.text + "," : " ";
          }
          retValue = viaText;
        } else retValue = " ";
        if(retValue == " "){
            retValue = "Non-Stop"
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_TICKETING_CONNECTION_FLIGHT,
          "error in getVia",
          err.toString(),
          "getVia",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
        },

        async created() {
            if (this.ticketingDetail)
                // console.log(this.ticketingDetail)
                
                this.ticketDetail = await this.getTicketingOrderDetails(
                    this.ticketingDetail
                );
            if (this.ticketDetail && this.ticketDetail.orderPassengerDetails) {
                this.ticketDetail = this.moveLeadPaxToFirst(this.ticketDetail);
                //    this.ticketDetail.orderPassengerDetails=this.ticketDetail.orderPassengerDetails.reverse();
                this.tcktDetLs = cloneData(this.ticketDetail);
                this.flightListbyGroup = this.getFlightListByGroup(this.tcktDetLs);
            }

            // await this.getRoutesResponse();
        }
    };
</script>
<style scoped>
    .highlight {
        background-color: #fbdede;
    }
</style>